export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["MILES"] = "miles";
    DistanceUnit["KILOMETERS"] = "kilometers";
    DistanceUnit["METERS"] = "meters";
    DistanceUnit["YARDS"] = "yards";
})(DistanceUnit || (DistanceUnit = {}));
export var CardioType;
(function (CardioType) {
    CardioType["TIME"] = "time";
    CardioType["DISTANCE"] = "distance";
    CardioType["REPETITIONS"] = "reps"; // Fixed number of reps (burpees, box jumps, etc.)
})(CardioType || (CardioType = {}));
//# sourceMappingURL=programs.js.map